import { usePostService, type ApiResponse } from "@libs/service-providers/api-service-provider";

import { LOGOUT_URL } from "./apiEndpoints";
import type { LogoutData } from "./types";

type UsePostLogoutOptions = {
  onSuccess?: (response: ApiResponse<LogoutData>) => void;
  onError?: (error: unknown) => void;
};

export const usePostLogout = (options?: UsePostLogoutOptions) => {
  const { onSuccess, onError, ...rest } = options ?? {};
  const mutation = usePostService<LogoutData, void>({
    route: LOGOUT_URL,
    onSuccess: onSuccess ? (data) => onSuccess(data) : undefined,
    onError: onError ? (err) => onError(err) : undefined,
    ...rest,
  });

  return {
    ...mutation,
    isLoading: mutation.status === "pending",
    mutate: () => {
      mutation.mutate();
    },
  };
};
